/** GraphEdit registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseGraphEdit } from './parser';
const graphEditRegistration = {
    typeName: 'GraphEdit',
    parser: parseGraphEdit,
};
nodeRegistry.register(graphEditRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map